import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Templates API
export const templatesAPI = {
  getAll: () => axios.get(`${API}/templates`, { headers: getAuthHeaders() }),
  getOne: (id) => axios.get(`${API}/templates/${id}`, { headers: getAuthHeaders() }),
  create: (data) => axios.post(`${API}/templates`, data, { headers: getAuthHeaders() }),
  update: (id, data) => axios.put(`${API}/templates/${id}`, data, { headers: getAuthHeaders() }),
  delete: (id) => axios.delete(`${API}/templates/${id}`, { headers: getAuthHeaders() }),
  duplicate: (id) => axios.post(`${API}/templates/${id}/duplicate`, {}, { headers: getAuthHeaders() })
};

// Domains API
export const domainsAPI = {
  getAll: () => axios.get(`${API}/domains`, { headers: getAuthHeaders() }),
  create: (data) => axios.post(`${API}/domains`, data, { headers: getAuthHeaders() }),
  update: (id, data) => axios.put(`${API}/domains/${id}`, data, { headers: getAuthHeaders() }),
  delete: (id) => axios.delete(`${API}/domains/${id}`, { headers: getAuthHeaders() })
};

// SendGrid API
export const sendGridAPI = {
  testEmail: (data) => axios.post(`${API}/sendgrid/test-email`, data, { headers: getAuthHeaders() }),
  getSenders: () => axios.get(`${API}/sendgrid/senders`, { headers: getAuthHeaders() }),
  createSender: (data) => axios.post(`${API}/sendgrid/senders`, data, { headers: getAuthHeaders() })
};

// Unsubscribe API
export const unsubscribeAPI = {
  unsubscribe: (data) => axios.post(`${API}/unsubscribe`, data),
  getLogs: () => axios.get(`${API}/unsubscribe-logs`, { headers: getAuthHeaders() })
};

// Dashboard API
export const dashboardAPI = {
  getStats: () => axios.get(`${API}/dashboard/stats`, { headers: getAuthHeaders() })
};
